<div class='bg'>

	<div class='bg-floor'>

		<mat-icon class='floor-icon' svgIcon='bg:floor'></mat-icon>

		<div class='bg-leo'>
			<mat-icon svgIcon='bg:sir-leo'></mat-icon>
		</div>
		<div class='bg-boxes'>
			<mat-icon svgIcon='bg:boxes'></mat-icon>
		</div>


		<div class='bg-left-tree'>
			<mat-icon svgIcon='bg:left-tree'></mat-icon>
		</div>


		<div class='bg-extend-left'>
			<mat-icon svgIcon='bg:extend-left'></mat-icon>
		</div>

		<!-- Stuff on the right -->
		<div class='bg-right-tree'>
			<mat-icon svgIcon='bg:right-tree'></mat-icon>
		</div>

		<div class='bg-right-truck'>
			<mat-icon svgIcon='bg:right-truck'></mat-icon>
		</div>

	</div>

	<!-- 130px high -->
	<div class='bg-fill'></div>

</div>
